module.exports = __webpack_public_path__ + "static/association_ind_member_badge-1e011220c6afb7cc62a8460f3689e448.svg";